export default __webpack_public_path__ + "static/media/ic_iran.c49a2390.svg";